import { render, staticRenderFns } from "./DashboardDataTable.vue?vue&type=template&id=8820708c&scoped=true"
import script from "./DashboardDataTable.vue?vue&type=script&lang=js"
export * from "./DashboardDataTable.vue?vue&type=script&lang=js"
import style0 from "./DashboardDataTable.vue?vue&type=style&index=0&id=8820708c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8820708c",
  null
  
)

export default component.exports